<template>
	<edit-template class="box" @confirm="submit" @cancel="$confirm('取消编辑?','提示',{type:'warning'}).then(res=>$router.back());" :cancelRemind="false" confirmText="保存" cancelText="取消">
		
    <el-form ref="form" :model="form" :rules="rules" class="form">
      <div class="title "></div>
      <el-form-item label="测评名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="应用角色">
        <p>{{ dataCont.role_text }}</p>
      </el-form-item>
      <el-form-item v-if="false" label="测试范围" prop="range">
        <el-checkbox-group v-show="false" v-model="form.range">
        </el-checkbox-group>
        <el-popover placement="right" trigger="click" :append-to-body="false" width="400">
          <el-tree :style="{
               maxHeight: '60vh',
               overflowY: 'auto'
              }" ref="tree" :data="testRangeData" :default-checked-keys="form.rangeShow" :default-expanded-keys="form.rangeShow" :props="defaultProps" :check-on-click-node="true" node-key="unique_id" show-checkbox="" @check="treeChange">
          </el-tree>
          <el-button slot="reference">点击选择</el-button>
        </el-popover>
        <div style="padding-left: 152rem;line-height: 30rem;padding-top: 10rem">
          <span v-for="(item,index) in form.rangeStr" style="word-break: keep-all;display: inline-block">
            {{ item }}
            {{index === form.rangeStr.length - 1 ? '' : '，'}}
          </span>
        </div>
      </el-form-item>
      <el-form-item label="选择问卷">
        <p>{{ dataCont.paper }}</p>
      </el-form-item>
      <el-form-item label="选择开始时间" prop="start_at">
        <el-date-picker v-model="startYMD" :default-value="new Date()" :editable="false" :picker-options="{
              disabledDate: (date) =>{
                return date.getTime() < Date.now() - 86400000
              }
            }" format="yyyy-MM-dd" placeholder="请选择" type="date" value-format="yyyy-MM-dd" @change="checkStart">
        </el-date-picker>
        <el-time-select v-model="startHM" :picker-options="{
              start: '00:00',
              step: '00:30',
              end: '23:30'
            }" placeholder="请选择" style="margin-left: 24rem" @change="checkStart">
        </el-time-select>
      </el-form-item>
      <el-form-item label="选择结束时间" prop="end_at">
        <el-date-picker v-model="endYMD" :default-value="new Date()" :disabled="!isStartChecked" :editable="false" :picker-options="endPickerOptions" format="yyyy-MM-dd" placeholder="请选择" type="date" value-format="yyyy-MM-dd" @change="checkEnd">
        </el-date-picker>
        <el-time-select v-model="endHM" :disabled="!isStartChecked" :picker-options="{
              start: '00:00',
              step: '00:30',
              end: '23:30'
            }" placeholder="请选择" style="margin-left: 24rem" @change="checkEnd">
        </el-time-select>
      </el-form-item>
      <el-form-item v-if="dataCont.role === 1" label="学生端展示最低版本" prop="version_id">
        <el-select v-model="form.version_id" placeholder="请选择">
          <el-option v-for="item in versionOptions" :key="item.id" :label="item.code" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item ref="img-box" label="展示图片" prop="image">
        <el-input v-show="false" v-model="form.image" placeholder="请输入内容"></el-input>
        <el-upload :before-upload="imgUploadBefore" :class="isUploaded ? 'is-uploaded' : ''" :headers="headers" :limit="1" :multiple="false" :on-preview="imgUploadPreview" :on-remove="imgUploadRemove" action="http://cms_api.dev.school.com/site/upload" list-type="picture-card" :file-list="fileList" :http-request="uploadImg" name="image">
          <i class="el-icon-plus"></i>
        </el-upload>
        <input type="file" ref="imgInput" v-show="false" @change="replaceImg">
        <el-dialog :visible.sync="dialogVisible">
          <img :src="dialogImageUrl" alt="" width="100%">
        </el-dialog>
        <div v-show="isUploaded" class="replace-img" @click="$refs.imgInput.click()">替换图片</div>
        <p style="padding-left: 152rem;color: #999">（请上传小于5M的png/jpg格式的图片，图片尺寸推荐使用1100*276）</p>
      </el-form-item>
    </el-form>


    
  
</edit-template>
</template>

<script>
import moment from 'moment'
import Tree from 'element-ui'

export default {
	_config:{"route":{"path":"edit","meta":{"title":"编辑"}}},
  data() {
    //检查结束时间是否大于开始时间
    let validatePass1 = (rule, value, callback) => {
      let startStr = this.startYMD + ' ' + this.startHM,
          endStr = this.endYMD + ' ' + this.endHM;
      let timeIsTrue = moment(startStr).format('x') < moment(endStr).format('x')
      if (!timeIsTrue) {
        callback(new Error('请仔细检查日期选项'));
      } else {
        callback()
      }
    };
    return {
      dataCont: '',
      headers: {
        // 'Content-Type': 'multipart/form-data',
        'authorization': 'Bearer ' + sessionStorage.getItem('TOKEN')
      },

      form: {
        name: null,
        role: '1',
        range: [],
        rangeShow: [],
        rangeStr: [],
        range_tree: [],
        paper_id: '',
        start_at: '',
        end_at: '',
        version_id: '',
        image: ''
      },

      //测试范围相关数据
      testRangeData: [],  //测试范围的选项配置，树形结构
      defaultProps: {
        children: 'children',
        label: 'label'
      },  //测试范围配置默认键名，label用于展示，

      //选择问卷选项配置
      paperOptions: [],

      //选择时间相关数据
      isStartChecked: false,  //开始时间是否已选
      endPickerOptions: {
        disabledDate: (date) => {
          return date.getTime() < moment(this.startYMD).format('x')
        }
      },
      startYMD: '',  //开始时间：年月日
      startHM: '',  //开始时间：时分
      endYMD: '',  //结束时间：年月日
      endHM: '',  //结束时间：时分

      //学生端最低版本选项配置
      versionOptions: [],

      //上传图片相关
      isUploaded: true,
      dialogImageUrl: '',
      dialogVisible: false,
      fileList: [],
      errorMessage: '',

      rules: {
        name: [{required: true, message: "请输入测评名称"}, {
          pattern: /^[\u4e00-\u9fa5\w]{1,30}$/,
          message: "请输入30字以内的汉字，数字和字母"
        }],
        range: [{required: true, message: "请选择测试范围"}],
        start_at: [{required: true, message: "请选择开始时间"}],
        end_at: [{required: true, message: "请选择结束时间"}, {validator: validatePass1}],
        version_id: [{required: true, message: "请选择学生端展示最低版本"}],
        image: [{required: true, message: "请上传展示图片"}],
      },
    }
  },
  created() {
    this.getRange()
    this.getVersion()
    this.getData()
  },
  methods: {
    //获取问卷配置
    // getPaper(value) {
    //   this.$_axios2('/api/evaluation/index/paper?type=' + value).then(res => {
    //     if (res.data.status === 0) {
    //       this.paperOptions = res.data.data
    //     }
    //   })
    // },

    //获取测评范围配置
    getRange() {
      this.$_axios2('/api/evaluation/index/range').then(res => {
        // console.log(res)
        if (res.data.status === 0) {
          this.testRangeData = res.data.data
        }
      })
    },

    getVersion() {
      this.$_axios2('/api/evaluation/index/version').then(res => {
        if (res.data.status === 0) {
          this.versionOptions = res.data.data
        }
      })
    },

    getData() {
      this.$_axios2('/api/evaluation/index/' + this.$route.query.id).then(res => {
        // console.log(res)
        if (res.data.status === 0) {
          this.dataCont = res.data.data
          this.form.name = res.data.data.name
          this.form.role = String(res.data.data.role)
          this.form.range = res.data.data.range
          this.form.rangeShow = JSON.parse(res.data.data.rangeShow)
          this.form.rangeStr = JSON.parse(res.data.data.rangeStr)
          this.form.range_tree = res.data.data.range_tree
          this.form.paper_id = res.data.data.paper_id
          this.form.start_at = res.data.data.start_at
          this.form.end_at = res.data.data.end_at
          this.form.version_id = res.data.data.version_id
          this.form.image = res.data.data.image
          this.fileList = [{name: res.data.data.image, url:res.data.data.image_url }]

          this.isStartChecked = true
          this.startYMD = res.data.data.start_at.slice(0,10)  //开始时间：年月日
          this.startHM = res.data.data.start_at.slice(11)  //开始时间：时分
          this.endYMD = res.data.data.end_at.slice(0,10)  //结束时间：年月日
          this.endHM = res.data.data.end_at.slice(11) //结束时间：时分

          // if(res.data.data.role === '学生'){
          //   this.getPaper(1)
          // }else{
          //   this.getPaper(2)
          // }

          // this.$forceUpdate()
          // console.log(this.form)
        }
      })
    },


    //测评范围改变
    treeChange(node, data) {
      this.form.range = []
      this.form.rangeShow = []
      this.form.rangeStr = []
      this.form.range_tree = []

      let list = JSON.parse(JSON.stringify(this.$refs.tree.getCheckedNodes(false,true)))
      list.forEach(item=>{
        if(item.children && item.children.length){
          delete item.children
        }
      })
      if (data.checkedNodes.length) {
        data.checkedNodes.forEach(item => {
          if (!item.children) {
            this.form.range.push(item.id)
            this.form.rangeStr.push(item.unique_id)
          }
        })
        this.form.rangeShow = data.checkedKeys
        this.form.range_tree = list
      }
    },

    //检测开始时间是否选中完毕
    checkStart(val) {
      // console.log(val)
      this.endYMD = ''
      this.endHM = ''
      this.form.end_at = ''
      let boo = this.startYMD && this.startHM
      this.isStartChecked = boo
      this.form.start_at = boo ? (this.startYMD + ' ' + this.startHM) : ''
    },

    //检测结束时间是否选中完毕
    checkEnd() {
      let endYMD = this.endYMD,
          endHM = this.endHM;
      this.form.end_at = (endYMD && endHM) ? (endYMD + ' ' + endHM) : ''
    },

    //图片上传前的回调
    imgUploadBefore(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message({
          type: 'error',
          message: '上传图片只能是 jpg/png 格式!',
          duration: 2000
        })
      }
      if (!isLt2M) {
        this.$message({
          type: 'error',
          message: '上传图片大小不能超过 5MB!',
          duration: 2000
        })
      }
      return isJPG && isLt2M;
    },

    //删除图片回调
    imgUploadRemove() {
      this.isUploaded = false
      this.form.image = ''
      this.errorMessage = '请上传展示图片'
    },

    //点击图片时的回调
    imgUploadPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    uploadImg(file){
      let boo = this.imgUploadBefore(file.file)
      if(boo){
        const loading = this.$loading({
          lock: true,
          text: '上传中',
          customClass: 'img-upload-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.$uploadToOSS(file.file).then(res => {
          this.$refs['img-box'].clearValidate()
          this.form.image = res.split('/').slice(-1).join()
          this.isUploaded = true
          this.fileList = [{
            name: file.filename,
            url: res
          }]
        }).finally(() => {
          loading.close()
        })
      }
    },

    replaceImg(e){
      this.uploadImg({file:e.target.files[0]})
    },


    submit() {

        this.$refs.form.validate().then(res => {
          this.$confirm('修改数据后，会对原来的数据产生影响，确定保存?', '提示', {
            confirmButtonText: '保存',
            cancelButtonText: '点错了',
            type: 'warning'
          }).then(() => {
            let params = {...this.form,}
            params.rangeShow = JSON.stringify(params.rangeShow)
            params.rangeStr = JSON.stringify(params.rangeStr)
            params.range_tree = JSON.stringify(params.range_tree)
            // console.log(params)
            this.$_axios2.post('/api/evaluation/index/' + this.dataCont.id, params).then(res => {
              // console.log(res)
              if(res.data.status === 0){
                this.$message({
                  message: '保存成功！',
                  type: 'success',
                  onClose: () => {
                    this.$router.back()
                  }
                })
              }
            })
          }).catch(() => {
          });
        }).catch(err => {
          // this.$message.warning("请输入完整的测评信息")
        })
    },

  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__label {
  width: 150rem;
}

::v-deep .is-uploaded .el-upload {
  display: none;
}

.box {
  .form {
    font-size: 14rem;
    margin: 0 0 20rem 50rem;
    min-height: calc(100vh - 220rem);

    ::v-deep .el-form-item__error {
      margin-left: 80rem;
    }

    .title {
      font-weight: bold;
      font-size: 16rem;
      padding-top: 35rem;
      margin-bottom: 35rem;
    }

    .el-form-item {
      margin-left: 50rem;
    }

    .subject {
      display: flex;
      align-items: center;

      ::v-deep .el-form-item__error {
        margin-left: 0;
      }

      //padding: 15rem 0rem;
      //justify-content: space-around;
      margin-bottom: 15rem;

      .item_box {
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: 15rem 10rem;
        flex: 1;
      }

      .item {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 10rem;

        > span {
          margin-right: 15rem;
        }

        .btn {
          border-radius: 50%;
          width: 30rem;
          height: 30rem;
          text-align: center;
          line-height: 30rem;
          cursor: pointer;
          margin-left: 15rem;
          border: 1rem solid #666666;
        }
      }

      .item.btns {
        width: 100rem;
        justify-content: flex-start;
        text-align: left;

        .btn {
          display: inline-block;
        }
      }

      .el-form-item {
        margin: 0;
      }

    }

    @media only screen and (max-width: 1399rem) {
      .subject {
        .item {
          display: block;
          text-align: center;

          > span {
            display: block;
            margin-right: 0;
            margin-bottom: 15rem;
          }

          ::v-deep .el-input {
            width: 180rem !important;
          }
        }

        .btns {
          width: 130rem;
          justify-content: flex-start;
          text-align: left;

          .btn {
            display: inline-block;
          }
        }
      }
    }
  }
}

.replace-img{
  width: 100rem;
  margin-left: 160rem;
  border: 1rem solid #999999;
  color: #666;
  border-radius: 6rem;
  height: 30rem;
  line-height: 30rem;
  text-align: center;
  cursor: pointer;
}
</style>
